export const clearFormat = (value: string, onlyCPF?: boolean) => {
  if (onlyCPF) {
    return value.trim().replace(/[^0-9]/g, '').slice(0,11);
  }
  return value.trim().replace(/[^0-9]/g, '');
}

export const formatCPFOrCNPJ = (value: string, onlyCPF?: boolean) => {
  const clean = clearFormat(value, onlyCPF);

  if (clean.match(/^\d{4,6}$/)) {
    return clean.slice(0, 3) + '.' + clean.slice(3);
  }

  if (clean.match(/^\d{7,9}$/)) {
    return clean.slice(0, 3) + '.' + clean.slice(3, 6) + '.' + clean.slice(6);
  }

  if (clean.match(/^\d{10,11}$/)) {
    return (
      clean.slice(0, 3) +
      '.' +
      clean.slice(3, 6) +
      '.' +
      clean.slice(6, 9) +
      '-' +
      clean.slice(9)
    );
  }

  if (clean.match(/^\d{12}$/)) {
    return (
      clean.slice(0, 2) +
      '.' +
      clean.slice(2, 5) +
      '.' +
      clean.slice(5, 8) +
      '/' +
      clean.slice(8)
    );
  }

  if (clean.match(/^\d{13,14}$/)) {
    return (
      clean.slice(0, 2) +
      '.' +
      clean.slice(2, 5) +
      '.' +
      clean.slice(5, 8) +
      '/' +
      clean.slice(8, 12) +
      '-' +
      clean.slice(12)
    );
  }

  return clean;
};
